"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginConfiguration = void 0;
var LoginConfiguration = /** @class */ (function () {
    function LoginConfiguration() {
        this.haloCIDPMechIdTest = 'm36147';
        this.haloCIDPMechIdProd = 'm38538';
        this.haloCServicesMechIdTest = 'm14185';
        this.haloCServicesMechIdProd = 'm14186';
        this.haloCAuthorizeEndpointTest = 'https://cloidc.stage.clogin.att.com/mga/sps/oauth/oauth20/authorize?';
        this.haloCAuthorizeEndpointProd = 'https://oidc.idp.clogin.att.com/mga/sps/oauth/oauth20/authorize?';
        this.haloCEndpointLogoutKMSIProdUrl = 'https://signin.att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&KMSI_SU=Y&returnURL=';
        this.haloCEndpointLogoutKMSITestUrl = 'https://signin.stage.clogin.att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&KMSI_SU=Y&returnURL=';
        this.haloCEndpointLogoutProdUrl = 'https://signin.att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&returnURL=';
        this.haloCEndpointLogoutTestUrl = 'https://signin.stage.clogin.att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&returnURL=';
        this.tgaurdAppIdStage = 'M81162';
        this.tguardAppIdProd = 'M81193';
        this.logoutLoadTimeout = 5000;
        this.logoutRedirectDelay = 250;
        this.urlWhitelistRegexp = [
            '^https?://att\\.com[/:]',
            '^https?://att\\.net[/:]',
            '^https?://([a-z0-9.\-]*)\\.att\\.com[/:]',
            '^https?://([a-z0-9.\-]*)\\.att\\.net[/:]',
            '^https?://directv\\.com/',
            '^https?://directvnow\\.com/',
            '^https?://atttv\\.com/',
            '^https?://atttvnow\\.com/',
            '^https?://([a-z0-9.\-]*)\\.atttv\\.com/',
            '^https?://([a-z0-9.\-]*)\\.atttvnow\\.com/',
            '^https?://([a-z0-9.\-]*)\\.directvnow\\.com/',
            '^https?://([a-z0-9.\-]*)\\.directv\\.com/',
            '^https?://([a-z0-9.\-]*)\\.directvnow\\.com/',
            '^https?://quickplay\\.com[/:]',
            '^https?://([a-z0-9.\-]*)\\.quickplay\\.com[/:]',
            '^https?://([a-z0-9.\-]*)\\.attwatchtv\\.com[/:]',
        ];
        this.testEnvironmentHostNameRegExps = [
            /\.stage\.att\.com/,
            /\.dev\.att\.com/,
            /test\d\.att\.com/,
            /perf\d\.att\.com/,
            /test-e\.att\.com/,
            /idp-dev-cloud\.att\.com/,
            /e-tst1-cloud\.stage\.att\.com/,
        ];
    }
    return LoginConfiguration;
}());
exports.LoginConfiguration = LoginConfiguration;
exports.default = new LoginConfiguration();
//# sourceMappingURL=LoginConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/services/LoginConfiguration.js
// module id = 157
// module chunks = 8